// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"05f8c4a7","455":"4a396351","977":"f742a9cb"}[chunkId] + ".chunk.js";
};